<template>
    <div class="panel">
        <div class="panel-body">

            <el-table
                    :data="assessmentTreeInfo"
                    style="width: 100%; margin-top:10px; margin-bottom: 25px; cursor: pointer"
                    border
                    highlight-current-row
                    :row-key="getRowKeys"
                    :expand-row-keys="expands"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    @row-click="clickTableRow"
                    @row-contextmenu="rightClick">
                <el-table-column prop="category" style="" label="考核项" min-width="80%">
                    <template slot-scope="scope">
                        <span :class="setErrorTdStyle(scope.row)">{{scope.row.seq == 0 ? "" : scope.row.seq}} {{scope.row.category}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="weight" :formatter="formatWeight" label="权重" min-width="10%">
                </el-table-column>
                <el-table-column prop="deservescore" label="应得分值" min-width="10%">
                </el-table-column>
                <!--<el-table-column prop="order" label="ORDER">
                </el-table-column>-->
            </el-table>

            <div id="menu" ref="menuDivRef">
                <div class="menu" v-for="(item,index) in menus" :key="index" @click.stop="infoClick(index)">{{item}}
                </div>
            </div>

            <conf-dialog :confRecordInfo="confRecordInfo" :confDialogVisible.sync="confDialogVisible"
                         @afterSavedConfRecord="afterSavedConfRecord"></conf-dialog>
        </div>

    </div>
</template>

<script type="text/javascript">

    import {createNamespacedHelpers} from "vuex";
    import confDialog from "./confDialog";
    import AssessmentServer from "../../../api/assessment";

    import {ASSESSMENT_PERMISSION} from '../assessment_common'

    const assessmentConfNSHelper = createNamespacedHelpers("assessment/assessmentConf");
    const assessmentVersionNSHelper = createNamespacedHelpers("assessment/assessmentVersion");

    export default {

        name: "AssessmentConfTable",

        components: {
            confDialog,
        },

        props: ['assessmentVersionDetail', 'offsetTop'],

        data() {
            return {

                menus: ['新增', '修改', '刪除', '上移', '下移'],

                currentRowIndex: 0, // 获取当前右键点击的table行下标

                //右键选中行后获得对应的配置详情
                confRecordInfo: {
                    id: 0,
                    category: '',
                    parent: '',
                    seq: '',
                    weight: 0,
                    deservescore: 100,
                    version: '',
                    changeby: localStorage.getItem("username"),
                    level: '',
                },

                confDialogVisible: false,

                canOper: true,

            }
        },

        methods: {

            ...assessmentConfNSHelper.mapActions(['getAssessmentConfTreeInfo']),
            ...assessmentVersionNSHelper.mapActions(['getAssessmentVersionDetail']),

            rightClick(row, column, event) {

                this.canOper = this.hasPermission(ASSESSMENT_PERMISSION);

                if (this.canOper == false) {
                    return;
                }

                //仅草稿状态允许修改
                if (this.assessmentVersionDetail.status != 'DRAFT') {
                    return;
                }

                let menu = document.querySelector("#menu");
                event.preventDefault();
                //获取我们自定义的右键菜单

                // 根据事件对象中鼠标点击的位置，进行定位
                menu.style.left = event.pageX - 55 + 'px';
                menu.style.top = event.pageY - this.offsetTop - 365 + 'px';
                // 改变自定义菜单的隐藏与显示
                menu.style.display = 'block';
                //当前选中行信息
                console.log(row, column);
                this.confRecordInfo = row;
                // 获取当前右键点击table下标
                this.assessmentTreeInfo.forEach((item, index) => {
                    if (item.category === row.category) {
                        this.currentRowIndex = index;
                        return false;
                    }
                })
            },

            // 自定义菜单的点击事件
            infoClick(index) {
                let that = this;
                let menu = document.querySelector("#menu");
                menu.style.display = 'none';

                if (that.confRecordInfo.level == 0 && (index != 0)) {
                    this.$message.error("禁止修改ROOT");
                    return;
                }

                if (index == 0) {
                    let tmpConfRecordInfo = {};
                    tmpConfRecordInfo.parent = this.confRecordInfo.id;
                    tmpConfRecordInfo.version = this.confRecordInfo.version;
                    tmpConfRecordInfo.level = this.confRecordInfo.level + 1;
                    tmpConfRecordInfo.seq = this.confRecordInfo.seq;

                    if (tmpConfRecordInfo.level == 4) {
                        this.$message.error("禁止继续添加层级！");
                        return;
                    }

                    //获取新序号
                    AssessmentServer.assessmentConf.seq(tmpConfRecordInfo).then(responseBody => {
                        this.confRecordInfo = tmpConfRecordInfo;
                        this.confRecordInfo.seq = responseBody.data.seq;
                        this.confRecordInfo.order = responseBody.data.order;
                        this.confRecordInfo.deservescore = 100;
                    });

                    this.confDialogVisible = true;
                } else if (index == 1) {
                    this.confDialogVisible = true;
                } else if (index == 2) {
                    this.$confirm('删除此考评项, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        AssessmentServer.assessmentConf.delete(that.confRecordInfo.id).then(res => {
                            if (res.data.code == 200) {
                                that.getAssessmentConfTreeInfo(that.assessmentVersionDetail.version);
                                that.getAssessmentVersionDetail(that.assessmentVersionDetail.id);
                            } else {
                                this.$message.error(res.data.message);
                            }
                        })
                    }).catch(() => {
                        console.log('已取消删除');
                    });
                } else if (index == 3) {
                    AssessmentServer.assessmentConf.up(this.confRecordInfo).then(responseBody => {
                        that.getAssessmentConfTreeInfo(this.assessmentVersionDetail.version);
                    });
                } else if (index == 4) {
                    AssessmentServer.assessmentConf.down(this.confRecordInfo).then(responseBody => {
                        that.getAssessmentConfTreeInfo(this.assessmentVersionDetail.version);
                    });
                }

            },

            // table的左键点击当前行事件
            clickTableRow(row, column, event) {
                let menu = document.querySelector("#menu");
                menu.style.display = 'none';
                // console.log(row);
                // this.assessmentTreeInfo.forEach((item, index) => {
                //
                // });
            },

            afterSavedConfRecord(params) {
                this.$emit('afterSavedConfRecord', params);
                this.getAssessmentConfTreeInfo(this.assessmentVersionDetail.version);
            },

            setErrorTdStyle(row) {
                if (this.errorIds.includes(row.id + '')) {
                    return 'red';
                }
                return '';
            },

            // 获取row的key值
            getRowKeys(row) {
                return row.id;
            },

            formatWeight(row, column) {
                if (row[column.property] != null) {
                    return `${row[column.property]}%`;
                } else {
                    return '';
                }
            },

        },

        watch: {
            assessmentVersionDetail: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    this.getAssessmentConfTreeInfo(newVal.version);
                }
            },
        },

        computed: {

            ...assessmentConfNSHelper.mapGetters(['assessmentTreeInfo', 'errorIds']),

            expands() {
                let arr = new Array();
                if (this.assessmentTreeInfo != null && this.assessmentTreeInfo.length != 0) {
                    arr.push(this.assessmentTreeInfo[0].id + '')
                }
                if (this.errorIds != null) {
                    arr = arr.concat([...this.errorIds]);
                }
                return arr;
            },

        },

        mounted() {

        },

        created() {

        },


    }
</script>

<style scoped>
    #menu {
        width: 120px;
        height: 128px;
        overflow: hidden; /*隐藏溢出的元素*/
        box-shadow: 0 1px 1px #888, 1px 0 1px #ccc;
        position: absolute;
        display: none;
        background: #ffffff;
        z-index: 10;
    }

    .menu {
        width: 125px;
        height: 25px;
        line-height: 25px;
        text-indent: 10px;
        cursor: pointer;
    }

    .menu:hover {
        color: deeppink;
        text-decoration: underline;
    }

</style>

